export const commonInputProps = {
  fullWidth: true,
  size: "small",
  mb: 0,
  marginTop: 0,
  inputFontSize: "0.8rem",
};

export const getCommonInputProps = (disabled = false) => ({
  ...commonInputProps,
  disabled,
});

export const commonAutoCompleteProps = {
  marginTop: 0,
  size: "small",
  sx: {
    "& .MuiOutlinedInput-input": {
      fontSize: "0.8rem !important",
    },
  },
  ListboxProps: {
    sx: {
      fontSize: "0.8rem !important",
      "& .MuiAutocomplete-option": {
        fontSize: "0.8rem !important",
        minHeight: "30px !important",
        padding: "4px 8px !important",
      },
    },
  },
  slotProps: {
    paper: {
      sx: {
        "& .MuiAutocomplete-option": {
          fontSize: "0.8rem !important",
          minHeight: "30px !important",
          padding: "4px 8px !important",
        },
      },
    },
    listbox: {
      sx: {
        fontSize: "0.8rem !important",
        "& .MuiAutocomplete-option": {
          fontSize: "0.8rem !important",
          minHeight: "30px !important",
          padding: "4px 8px !important",
        },
      },
    },
  },
  componentsProps: {
    popper: {
      sx: {
        "& .MuiAutocomplete-option": {
          fontSize: "0.8rem !important",
          minHeight: "30px !important",
          padding: "4px 8px !important",
        },
      },
    },
  },
};
